import { createSlice, PayloadAction, Reducer } from '@reduxjs/toolkit';

import { UserCompanyUiFeaturesType } from 'domain/api/graphql/generated';

import { FeatureFlagsState } from './types';
import { buildFeatureFlags, FEATURE_FLAGS_INITIAL_STATE, FEATURE_FLAGS_SLICE_NAME } from './consts';

const featureFlagsSlice = createSlice({
  name: FEATURE_FLAGS_SLICE_NAME,
  initialState: FEATURE_FLAGS_INITIAL_STATE,
  reducers: {
    initBuildFlags: (state) => {
      state.buildFlags = buildFeatureFlags;
      state.combinedFlags = { ...state.runtimeFlags, ...buildFeatureFlags };
    },
    setRuntimeFlags: (state, action: PayloadAction<UserCompanyUiFeaturesType>) => {
      state.runtimeFlags = action.payload;
      state.combinedFlags = { ...state.buildFlags, ...action.payload };
    },
    setBuildFlags: (state, action: PayloadAction<Record<string, boolean>>) => {
      state.buildFlags = action.payload;
      state.combinedFlags = { ...state.runtimeFlags, ...action.payload };
    },
    setCombinedFlags: (state, action: PayloadAction<UserCompanyUiFeaturesType>) => {
      state.combinedFlags = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    resetFeatureFlags: () => FEATURE_FLAGS_INITIAL_STATE,
  },
});

export const { initBuildFlags, setRuntimeFlags, setBuildFlags, setCombinedFlags, setIsLoading, resetFeatureFlags } =
  featureFlagsSlice.actions;

export const featureFlagsReducer: Reducer<FeatureFlagsState> = featureFlagsSlice.reducer;
